import { i18n } from '@fs/zion-locale'

export default {
  cancelButtonText: () => i18n.t('groupData.cancelButtonText', 'Cancel'),
  changesSavedSuccessMessage: () => i18n.t('groupData.changesSavedSuccessMessage', 'Changes saved successfully'),
  errorSaveMessage: () => i18n.t('groupData.errorSaveMessage', 'Oops! There was an error saving... Please try again'),
  failureSaveMessage: () =>
    i18n.t(
      'groupData.partialFailureSaveMessage',
      'Some fields did not save correctly. Make sure you entered valid input. Use the Feedback button if the error continues.'
    ),
  invalidCoverage: () =>
    i18n.t('groupData.invalidCoverage', 'A place, record type, and date are required to complete the audit.'),
  removeSelected: () => i18n.t('groupData.removeSelected', 'Remove Selected'),
  saveAndSubmitButtonText: () => i18n.t('groupData.saveAndSubmitButtonText', 'Save and Submit'),
  submitAuditButtonText: () => i18n.t('groupData.submitAuditButtonText', 'Submit Audit'),
  saveButtonText: () => i18n.t('groupData.saveButtonText', 'Save'),
  saveCheckbox: () => i18n.t('groupData.saveCheckbox', 'I described the image group, not just one image.'),
  successfulSaveMessage: () => i18n.t('groupData.successfulSaveMessage', 'Successfully saved'),

  /* Image Organize */
  doneDividing: () => i18n.t('groupData.doneDividing', 'Done Dividing'),
  metadataIsCorrect: () => i18n.t('groupData.metadataIsCorrect', 'Metadata Is Correct'),
  skip: () => i18n.t('groupData.skip', 'Skip'),
  coverageErrorMessage: () =>
    i18n.t(
      'groupData.coveragesErrorMessage',
      'There is an error with one or more of the place, date, or record type fields.'
    ),
  submitForOrganizingButton: () => i18n.t('groupData.submitForOrganizingButton', 'Submit for Organizing'),
  unsavedChangesHeader: () => i18n.t('metaDataOverlay.unsavedChangesHeader', 'You have unsaved changes'),
  leave: () => i18n.t('metaDataOverlay.leaveButton', 'Leave'),
  continueEditing: () => i18n.t('metaDataOverlay.continueEditingButton', 'Continue Editing'),
  areYouSure: () =>
    i18n.t(
      'metaDataOverlay.unsavedChangesBody',
      'Are you sure you want to leave edit mode? The changes you made will not be saved.'
    ),
}
